const ports = [
  {
    slug: "openttd",
    name: "OpenTTD",
    description: "Open-source transport management simulation.",
    path: "/ports/openttd/",
    repoUrl: "https://github.com/msadev/OpenTTD",
    upstreamUrl: "https://github.com/OpenTTD/OpenTTD",
    tags: ["multiplayer"]
  },
  {
    slug: "openrct2",
    name: "OpenRCT2",
    description: "Theme park construction and management.",
    path: "/ports/openrct2/",
    repoUrl: "https://github.com/msadev/OpenRCT2",
    upstreamUrl: "https://github.com/OpenRCT2/OpenRCT2",
    tags: ["multiplayer", "requires original assets"]
  }
];

export default ports;
